jQuery(($) => {

    if ($('.o-wide-gallery-slider')[0]) {
        var dotsNavigation   = $('.o-wide-gallery-slider__dots-navigation'),
            arrowsNavigation = $('.o-wide-gallery-slider__arrows-navigation');

        $('.o-wide-gallery-slider .m-gallery-images--slider .m-gallery-images__list').slick({
            infinite: true,
            fade: true,
            dots: true,
            appendDots: dotsNavigation,
            appendArrows: arrowsNavigation,
            swipetoSlide:false,
            centerMode:true
        });
    }
});